import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { ChangeUpsellActivityPayload } from "../../payload/ChangeUpsellActivity/ChangeUpsellActivityPayload";

const changeUpsellActivityFetch = (state: UpsellState, action: PayloadAction<ChangeUpsellActivityPayload>) => {
    state.isLoading = true;
}

export default changeUpsellActivityFetch;